import { useTranslation } from 'react-i18next';
import * as v from 'valibot';
export function useModuleSchema() {
    const { t } = useTranslation();
    const schema = v.object({
        extra: v.boolean(),
        paidModule: v.boolean(),
        publicModule: v.boolean(),
        cover: v.union([
            v.object({
                id: v.string(),
                name: v.string(),
                url: v.string()
            }),
            v.null()
        ]),
        name: v.pipe(v.string(), v.nonEmpty(t('modules.form.name.errors.required'))),
        classes: v.pipe(v.array(v.string()), v.minLength(1, t('modules.form.name.errors.required')))
    });
    return schema;
}
